import React, { useCallback, useEffect, useRef, useState } from 'react'
import ReactPlayer from 'react-player'

import { useResponsiveLayout } from 'Hooks'

import { VIDEO_LINK, VIDEO_RATIO } from './constants'
import { Container, Content } from './styles'

function ExecutiveInviteHeroSectionGallery() {
  const { isWideDesktop } = useResponsiveLayout()

  const [contentWidth, setContentWidth] = useState<string | number>(0)
  const [contentHeight, setContentHeight] = useState(0)

  const containerRef = useRef<HTMLDivElement>(null)

  const calculateDimensions = useCallback(
    (containerWidth: number, containerHeight: number) => {
      if (!isWideDesktop) {
        return {
          width: containerWidth,
          height: containerWidth / VIDEO_RATIO,
        }
      } else {
        const widthBasedHeight = containerWidth / VIDEO_RATIO
        const heightBasedWidth = containerHeight * VIDEO_RATIO
        const useWidthBased = widthBasedHeight >= containerHeight

        return {
          width: useWidthBased ? containerWidth : heightBasedWidth,
          height: useWidthBased ? widthBasedHeight : containerHeight,
        }
      }
    },
    [isWideDesktop],
  )

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleResize = (entries: ResizeObserverEntry[]) => {
      const { width: containerWidth, height: containerHeight } =
        entries[0].contentRect
      const dimensions = calculateDimensions(containerWidth, containerHeight)
      setContentWidth(dimensions.width)
      setContentHeight(dimensions.height)
    }

    const observer = new ResizeObserver(handleResize)
    observer.observe(container)

    const forceRecalculation = () => {
      const rect = container.getBoundingClientRect()
      const dimensions = calculateDimensions(rect.width, rect.height)
      setContentWidth(dimensions.width)
      setContentHeight(dimensions.height)
    }

    forceRecalculation()

    return () => observer.disconnect()
  }, [calculateDimensions])

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const rect = container.getBoundingClientRect()
    const dimensions = calculateDimensions(rect.width, rect.height)

    setContentHeight(0) // Force reset

    requestAnimationFrame(() => {
      setContentWidth(dimensions.width)
      setContentHeight(dimensions.height)
    })
  }, [isWideDesktop, calculateDimensions])

  return (
    <Container ref={containerRef}>
      <Content height={contentHeight} width={contentWidth}>
        <ReactPlayer
          className="react-player"
          controls={false}
          height={contentHeight}
          loop
          muted
          playing
          url={VIDEO_LINK}
          width={contentWidth}
        />
      </Content>
    </Container>
  )
}

export default ExecutiveInviteHeroSectionGallery
